(function () {
    'use strict';

    angular
        .module('app')
        .factory('CriticalPathService', CriticalPathService);

    function CriticalPathService($http, $q, WebAPIUrl, WebApiService) {

        var service = {
            getCriticalPathDevPatternDetails: getCriticalPathDevPatternDetails,
            getLinePlanProcessDates: getLinePlanProcessDates,
            isCPDevPatternNameExists: isCPDevPatternNameExists,
            getCriticalPathHeaderStatusList: getCriticalPathHeaderStatusList,
            updateCriticalPathDevPattern: updateCriticalPathDevPattern,
            getReport: getReport,
            getDevPrototype: getDevPrototype,
            getDevPrototypeWithProcesses: getDevPrototypeWithProcesses,
            getStockNumberModels: getStockNumberModels,
            updateCriticalPathDevPrototype: updateCriticalPathDevPrototype,
            getCriticalPathPrototypeLinePlanProcessDates: getCriticalPathPrototypeLinePlanProcessDates,
            getDevPatternsForDevPrototype: getDevPatternsForDevPrototype,
            getGetDevPrototypesForDevPattern: getGetDevPrototypesForDevPattern,
            getCpCommercializationsForPattern: getCpCommercializationsForPattern,
            getCpCommercializationsForPrototype: getCpCommercializationsForPrototype,
            getCPCommercializationDetails: getCPCommercializationDetails,
            getStockNumbers: getStockNumbers,
            updateCriticalPathCommercialization: updateCriticalPathCommercialization,
            isCPCommercializationNameExists: isCPCommercializationNameExists,
            getCriticalPathCommercializationProcesses: getCriticalPathCommercializationProcesses,
            getCriticalPathProcessApprovedList: getCriticalPathProcessApprovedList,
            getPatternPurchaseOrders: getPatternPurchaseOrders,
            getPrototypePurchaseOrders: getPrototypePurchaseOrders,
            getBrandsByCriticalPath: getBrandsByCriticalPath,
            getCriticalPathDevPatterns: getCriticalPathDevPatterns,
            getCriticalPathDevProtos: getCriticalPathDevProtos,
            getCriticalPathCommercializations: getCriticalPathCommercializations,
            getCountryOfOriginList: getCountryOfOriginList,
            getCPDevProtoCommercializations: getCPDevProtoCommercializations,
            getCPCommDevPatterns: getCPCommDevPatterns,
            getDevPrototypesForCommercialization: getDevPrototypesForCommercialization,
            CreateCriticalPathCommercialization: CreateCriticalPathCommercialization,
            CreateDevCriticalPath: CreateDevCriticalPath,
            canDevProtoCriticalPathBeCanceled: canDevProtoCriticalPathBeCanceled,
            canDevPatternCriticalPathBeCanceled: canDevPatternCriticalPathBeCanceled,
            canCommercializationBeCanceled: canCommercializationBeCanceled
        };

        return service;


        function getCriticalPathDevPatternDetails(patternSeasonalId) {
            var deferred = $q.defer();
            $http({
                method: 'GET',
                url: WebAPIUrl + '/api/CriticalPath/CriticalPathDevPatternDetails?PatternSeasonalId=' + patternSeasonalId,
            }).success(function (data, status, headers, cfg) {
                deferred.resolve(data);
            }).error(function (err, status) {
                if (status == 404) {
                    deferred.resolve(null);
                } else {
                    alert(err);
                    deferred.reject(err, status);
                }
            });

            return deferred.promise;
        }

        function getLinePlanProcessDates(criticalPathDevPatternId, processName) {
            var deferred = $q.defer();
            $http({
                method: 'GET',
                url: WebAPIUrl + '/api/CriticalPath/LinePlanProcessDates?CriticalPathDevPatternId=' + criticalPathDevPatternId + '&ProcessName=' + processName
            }).success(function (data, status, headers, cfg) {
                deferred.resolve(data);
            }).error(function (err, status) {
                deferred.reject(err, status);
            });

            return deferred.promise;
        }

        function isCPDevPatternNameExists(cpDevPatternId, cpDevPatternName) {
            var deferred = $q.defer();

            $http({
                method: 'GET',
                url: WebAPIUrl + '/api/CriticalPath/IsCPDevPatternNameExists?CPDevPatternId=' + cpDevPatternId + '&CPDevPatternName=' + cpDevPatternName
            }).success(function (data, status, headers, cfg) {
                deferred.resolve(data);
            }).error(function (err, status) {
                //alert('error');
                deferred.reject(err, status);
            });

            return deferred.promise;

        }

        function getCriticalPathHeaderStatusList() {

            var deferred = $q.defer();
            $http({
                method: 'GET',
                url: WebAPIUrl + '/api/CriticalPath/CriticalPathHeaderStatusList',
            }).success(function (data, status, headers, cfg) {
                deferred.resolve(data);
            }).error(function (err, status) {
                deferred.reject(err, status);
            });

            return deferred.promise;
        }

        function updateCriticalPathDevPattern(criticalPathDevPatternData, criticalPathDevPatternProcessesData) {
            var deferred = $q.defer();
            $http({
                method: 'POST',
                url: WebAPIUrl + "/api/CriticalPath/UpdateCriticalPathDevPattern",
                data: { cpDevPatternData: criticalPathDevPatternData, cpDevPatternProcessesData: criticalPathDevPatternProcessesData },
                //ignoreLoadingBar: true
            }).success(function (data, status, headers, cfg) {
                deferred.resolve(data);
            }).error(function (err, status) {
                deferred.reject(err, status);
            });

            return deferred.promise;
        }

        function getReport() {
            var deferred = $q.defer();
            $http({
                method: 'GET',
                url: WebAPIUrl + '/api/Report/CriticalPathDevPatternReport',
            }).success(function (data, status, headers, cfg) {
                deferred.resolve(data);
            }).error(function (err, status) {
                deferred.reject(err, status);
            });

            return deferred.promise;
        }

        function getDevPrototype(devPrototypeId) {
            return WebApiService.get("/api/CriticalPath/DevPrototype?devPrototypeId=" + devPrototypeId);
        }

        function getDevPrototypeWithProcesses(devPrototypeId) {
            return WebApiService.get("/api/CriticalPath/DevPrototypeWithProcesses?devPrototypeId=" + devPrototypeId, null, { ignoreLoadingBar: false});
        }

        function getStockNumberModels(devPrototypeId) {
            return WebApiService.get("/api/CriticalPath/StockNumberModels?devPrototypeId=" + devPrototypeId, null, { ignoreLoadingBar: true });
        }

        function updateCriticalPathDevPrototype(devPrototype, actualProcesses, finalProcesses, stockNumberModels) {
            var data = {
                CriticalPathDevPrototype: devPrototype,
                ActualProcesses: actualProcesses,
                FinalProcesses: finalProcesses,
                StockNumberModels: stockNumberModels
            };
            return WebApiService.postJson("/api/CriticalPath/UpdateCriticalPathDevPrototype", data);
        }

        function getCriticalPathPrototypeLinePlanProcessDates(criticalPathDevPrototypeId, processName, prototypeSeasonalId) {
            var deferred = $q.defer();
            $http({
                method: 'GET',
                url: WebAPIUrl + '/api/CriticalPath/CriticalPathPrototypeLinePlanProcessDates?CriticalPathDevPrototypeId=' + criticalPathDevPrototypeId + '&ProcessName=' + processName + '&prototypeSeasonalId=' + prototypeSeasonalId
            }).success(function (data, status, headers, cfg) {
                deferred.resolve(data);
            }).error(function (err, status) {
                deferred.reject(err, status);
            });

            return deferred.promise;
        }

        function getDevPatternsForDevPrototype(criticalPathDevPrototypeId) {
            return WebApiService.get("/api/CriticalPath/GetDevPatternsForDevPrototype?criticalPathDevPrototypeId=" + criticalPathDevPrototypeId);
        }

        function getGetDevPrototypesForDevPattern(criticalPathDevPatternId) {
            return WebApiService.get("/api/CriticalPath/GetDevPrototypesForDevPattern?CriticalPathDevPatternId=" + criticalPathDevPatternId);
        }

        function getCpCommercializationsForPattern(patternId) {

            var deferred = $q.defer();
            $http({
                method: 'GET',
                url: WebAPIUrl + '/api/CriticalPath/CpCommercializationsForPattern?patternId=' + patternId,
            }).success(function (data, status, headers, cfg) {
                deferred.resolve(data);
            }).error(function (err, status) {
                deferred.reject(err, status);
            });

            return deferred.promise;
        }

        function getCpCommercializationsForPrototype(prototypeSeasonalId) {
            var deferred = $q.defer();
            $http({
                method: 'GET',
                url: WebAPIUrl + '/api/CriticalPath/CpCommercializationsForPrototype?prototypeSeasonalId=' + prototypeSeasonalId
            }).success(function (data, status, headers, cfg) {
                deferred.resolve(data);
            }).error(function (err, status) {
                deferred.reject(err, status);
            });

            return deferred.promise;
        }

        function getCPCommercializationDetails(criticalPathCommercializationId) {
            var deferred = $q.defer();
            $http({
                method: 'GET',
                url: WebAPIUrl + '/api/CriticalPath/CPCommercializationDetails?CriticalPathCommercializationId=' + criticalPathCommercializationId,
            }).success(function (data, status, headers, cfg) {
                deferred.resolve(data);
            }).error(function (err, status) {
                deferred.reject(err, status);
            });

            return deferred.promise;
        }

        function getStockNumbers(patternId, factoryKey) {
            var deferred = $q.defer();
            $http({
                method: 'GET',
                url: WebAPIUrl + '/api/CriticalPath/GetStockNumbers?PatternId=' + patternId + '&FactoryKey=' + factoryKey,
            }).success(function (data, status, headers, cfg) {
                deferred.resolve(data);
            }).error(function (err, status) {
                deferred.reject(err, status);
            });

            return deferred.promise;
        }

        function updateCriticalPathCommercialization(criticalPath, processes) {
            var postData = {
                criticalPath: criticalPath,
                processes: processes
            };

            return WebApiService.postJson("/api/CriticalPath/UpdateCriticalPathCommercialization", postData, {}, false);
        }

        function isCPCommercializationNameExists(cpCommercializationId, cpName) {
            var deferred = $q.defer();

            $http({
                method: 'GET',
                url: WebAPIUrl + '/api/CriticalPath/IsCPCommercializationNameExists?CPCommercializationId=' + cpCommercializationId + '&CPName=' + cpName,
                ignoreLoadingBar: true
            }).success(function (data, status, headers, cfg) {
                deferred.resolve(data);
            }).error(function (err, status) {
                //alert('error');
                dererred.reject(err, status);
            });

            return deferred.promise;

        }

        function getCriticalPathCommercializationProcesses(criticalPathCommercializationId) {

            var deferred = $q.defer();
            $http({
                method: 'GET',
                url: WebAPIUrl + '/api/CriticalPath/CriticalPathCommercializationProcesses?CriticalPathCommercializationId=' + criticalPathCommercializationId
            }).success(function (data, status, headers, cfg) {
                deferred.resolve(data);
            }).error(function (err, status) {
                deferred.reject(err, status);
            });

            return deferred.promise;
        }

        function getCriticalPathProcessApprovedList() {

            var deferred = $q.defer();
            $http({
                method: 'GET',
                url: WebAPIUrl + '/api/CriticalPath/CriticalPathProcessApprovedList',
            }).success(function (data, status, headers, cfg) {
                deferred.resolve(data);
            }).error(function (err, status) {
                deferred.reject(err, status);
            });

            return deferred.promise;
        }

        function getPrototypePurchaseOrders(prototypeSeasonalId) {
            return WebApiService.get("/api/CriticalPath/PrototypePurchaseOrders?prototypeSeasonalId=" + prototypeSeasonalId);
        }

        function getPatternPurchaseOrders(patternId, factoryKey) {
            return WebApiService.get("/api/CriticalPath/PatternPurchaseOrders?patternId=" + patternId + "&factoryKey=" + factoryKey);
        }

        function getBrandsByCriticalPath(criticalPathTypeId) {

            var deferred = $q.defer();
            $http({
                method: 'GET',
                url: WebAPIUrl + '/api/CriticalPath/BrandsByCriticalPath?CriticalPathTypeId=' + criticalPathTypeId
            }).success(function (data, status, headers, cfg) {
                deferred.resolve(data);
            }).error(function (err, status) {
                deferred.reject(err, status);
            });

            return deferred.promise;
        }

        function getCriticalPathDevPatterns(criticalPathSearchData) {
            var deferred = $q.defer();
            $http({
                method: 'POST',
                url: WebAPIUrl + "/api/CriticalPath/CriticalPathDevPatterns",
                data: { cpSearchData: criticalPathSearchData },
                ignoreLoadingBar: false
            }).success(function (data, status, headers, cfg) {
                deferred.resolve(data);
            }).error(function (err, status) {
                deferred.reject(err, status);
            });

            return deferred.promise;
        }

        function getCriticalPathDevProtos(criticalPathSearchData) {
            return WebApiService.postJson("/api/CriticalPath/CriticalPathDevProtos", criticalPathSearchData);
        }

        function getCriticalPathCommercializations(criticalPathSearchData) {
            var deferred = $q.defer();
            $http({
                method: 'POST',
                url: WebAPIUrl + "/api/CriticalPath/CriticalPathCommercializations",
                data: { cpSearchData: criticalPathSearchData },
                ignoreLoadingBar: false
            }).success(function (data, status, headers, cfg) {
                deferred.resolve(data);
            }).error(function (err, status) {
                deferred.reject(err, status);
            });

            return deferred.promise;
        }

        function getCountryOfOriginList() {
            var deferred = $q.defer();
            $http({
                method: 'GET',
                url: WebAPIUrl + '/api/CriticalPath/CountryOriginList',
            }).success(function (data, status, headers, cfg) {
                deferred.resolve(data);
            }).error(function (err, status) {
                deferred.reject(err, status);
            });

            return deferred.promise;
        }

        function getCPDevProtoCommercializations(prototypeSeasonalId) {

            var deferred = $q.defer();
            $http({
                method: 'GET',
                url: WebAPIUrl + '/api/CriticalPath/CPDevProtoCommercializations?PrototypeSeasonalId=' + prototypeSeasonalId,
            }).success(function (data, status, headers, cfg) {
                deferred.resolve(data);
            }).error(function (err, status) {
                deferred.reject(err, status);
            });

            return deferred.promise;
        }

        function getCPCommDevPatterns(patternId) {
            var deferred = $q.defer();
            $http({
                method: 'GET',
                url: WebAPIUrl + '/api/CriticalPath/CPCommDevPatterns?PatternId=' + patternId,
            }).success(function (data, status, headers, cfg) {
                deferred.resolve(data);
            }).error(function (err, status) {
                deferred.reject(err, status);
            });

            return deferred.promise;
        }

        function getDevPrototypesForCommercialization(commercializationId) {
            return WebApiService.get("/api/CriticalPath/GetDevPrototypesForCommercialization?commercializationId=" + commercializationId);
        }

        function CreateDevCriticalPath(ProtypeID, PrototypeSeasonalID, UserID) {
            var deferred = $q.defer();
            $http({
                method: 'GET',
                url: WebAPIUrl + '/api/CriticalPath/CreateDevCriticalPath?ProtypeID=' + ProtypeID + "&PrototypeSeasonalID=" + PrototypeSeasonalID + "&UserID=" + UserID,
            }).success(function (data, status, headers, cfg) {
                deferred.resolve(data);
            }).error(function (err, status) {
                deferred.reject(err, status);
            });

            return deferred.promise;

        }

        function canDevPatternCriticalPathBeCanceled(criticalPathDevPatternId) {
            return WebApiService.get("/api/CriticalPath/CanDevPatternCriticalPathBeCanceled?CriticalPathDevPatternId=" + criticalPathDevPatternId);
        }

        function canCommercializationBeCanceled(criticalPathCommercializationId) {
            return WebApiService.get("/api/CriticalPath/CanCommercializationBeCanceled?CriticalPathCommercializationId=" + criticalPathCommercializationId);
        }

        function canDevProtoCriticalPathBeCanceled(criticalPathDevPrototypeId) {
            return WebApiService.get("/api/CriticalPath/CanDevProtoCriticalPathBeCanceled?CriticalPathDevPrototypeId=" + criticalPathDevPrototypeId);
        }

        //for special use only. Consult Ben or Dan
        function CreateCriticalPathCommercialization(prototypeSeasonalId) {
            return WebApiService.postJson("/api/CriticalPath/CreateCriticalPathCommercialization?prototypeSeasonalId=" + prototypeSeasonalId);
        }
    }

})();
